export const validateAdvancePayment = ({ amount, destinationType, destinationBalance, enableAdvancePayment }) => {
  if (
    ["WORKER", "VENDOR", "SUBCONTRACTOR"].includes(destinationType) &&
    !enableAdvancePayment &&
    destinationBalance !== null &&
    Number(amount) > Number(destinationBalance)
  ) {
    return `Amount cannot exceed available balance of ${Number(destinationBalance).toLocaleString()}`;
  }

  return null;
};

export const addTransactionValidationRules = (values, type, options = {}) => {
  const errors = {};
  const { destinationBalance = null, enableAdvancePayment = true } = options;

  if (!values.destinationId) errors.destinationId = `Please select a ${type.toLowerCase()}`;
  if (!values.amount) errors.amount = "Amount is required";
  else if (values.amount < 1) errors.amount = "Amount must be greater than 0";
  else {
    const amountError = validateAdvancePayment({
      amount: values.amount,
      destinationType: type,
      destinationBalance,
      enableAdvancePayment,
    });

    if (amountError) errors.amount = amountError;
  }
  if (!values.date) errors.date = "Date is required";
  if (!values.fromAccountId) errors.fromAccountId = "Please select a from account";
  if (type === "SUBCONTRACTOR" && !values.projectId) errors.projectId = "Please select a project";

  return errors;
};

export const editTransactionValidationRules = (values, type, options = {}) => {
  const errors = {};
  const { destinationBalance = null, enableAdvancePayment = true } = options;

  if (!values.toAccountId) errors.toAccountId = "Please select a to account";
  if (!values.amount) errors.amount = "Amount is required";
  else if (values.amount < 1) errors.amount = "Amount must be greater than 0";
  else {
    const amountError = validateAdvancePayment({
      amount: values.amount,
      destinationType: type,
      destinationBalance,
      enableAdvancePayment,
    });

    if (amountError) errors.amount = amountError;
  }
  if (!values.date) errors.date = "Date is required";
  if (!values.subcontractorId && !values.fromAccountId) errors.fromAccountId = "Please select a from account";
  if (type === "SUBCONTRACTOR" && !values.projectId) errors.projectId = "Please select a project";

  return errors;
};
